module.exports = __webpack_public_path__ + "static/media/cont614.c1616a4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont614.mp4
// module id = 6vpC
// module chunks = 0